/**
 * The client half of email confirmation: what each way a link can fail actually says to the
 * person holding it.
 *
 * `lib/oauth.ts`'s arrangement, for its reason — the server answers with a code so the detail
 * stays out of a URL the browser keeps in its history, and turning the code back into a sentence
 * is this side's job. An unrecognised one is still a sentence rather than a blank screen.
 */

import type { VerifyEmailFailure } from '@chompdome/shared/constants';

/**
 * `used` IS NOT AN ERROR, and that is the whole reason these are three messages rather than one.
 *
 * The commonest thing that happens to a confirmation link is being clicked twice — a mail app
 * that pre-fetches, a back button, somebody making sure. Telling that player "this link is not
 * one of ours" is how a confirmation that worked perfectly comes to read as a broken product.
 */
const FAILURE_MESSAGES: Record<VerifyEmailFailure, string> = {
  expired: 'That confirmation link has expired. Ask for a new one and we will send another.',
  used: 'That link has already been used — your email is confirmed. You can sign in.',
  invalid:
    'That confirmation link is not one of ours. It may have been cut short by your mail app.',
};

export function verifyEmailFailureMessage(failure: VerifyEmailFailure | undefined): string {
  const known = failure === undefined ? undefined : FAILURE_MESSAGES[failure];
  return known ?? 'We could not confirm that link. Ask for a new one from the sign-in page.';
}

/** Is this failure one the player fixes by asking for another mail? */
export function offersResend(failure: VerifyEmailFailure | undefined): boolean {
  return failure === 'expired' || failure === 'invalid';
}
